if ($('section').hasClass('home')) {
    $('section').children('article').first().addClass('fst-home');
} else {
    $('section').children('article').first().addClass('fst');
}

if ($('table.nomenclatur').length > 0) {
    if ($(this).find('td').is(':empty') || $(this).find('td').text('&nbsp;')) {
        $(this).parent('tr').addClass('tmhide');
    }
}

$('.tx-ewproduct table.grades select, .tx-ewproduct table.kb-list select').each(function() {
    if ($(this).find('option').length == 1) {
        $(this).addClass('lange');
    }
});

$('.darksite .close-darksite').on('click', function () {
    document.cookie = "darksite=1; path=/";
    $(this).closest('.darksite').fadeOut(300);
});

// nomenclatur view toogle
var $toggleTableLink = $('.nomenclatur th.t-toggle a');
var labelShow = $toggleTableLink.attr('data-show');
var labelHide = $toggleTableLink.attr('data-hide');

$toggleTableLink.html("<i class=\"icon ion-md-funnel\"></i>&nbsp;" + labelShow);
$toggleTableLink.on('click', function(event) {
    event.preventDefault();
    var UITBody = $("table.nomenclatur tbody");
    if ( (UITBody).hasClass("show") ){
        UITBody.removeClass("show");
        $toggleTableLink.html("<i class=\"icon ion-md-funnel\"></i>&nbsp;" + labelShow);
    } else {
        $toggleTableLink.html("<i class=\"icon ion-md-funnel\"></i>&nbsp;" + labelHide);
        UITBody.addClass("show");
    }
});

// knowledge base modal
$('#kb-modal').popup({
    closebutton: true,
});

$('.anchor-link').on('click', function () {
    $('#kb-modal input').val($(this).attr('href'));
    $('#kb-modal').popup('show');

    return false;
});

$('#kb-modal .copy').on('click', function () {
    $(this).prev('input').select();
    document.execCommand('copy');
});